<div
  class="top-bar-categories align-items-center mb-3"
  [class.p-0]="innerWidth < 450"
  [class.pl-1]="innerWidth < 450"
  (window:resize)="onResize($event)"
>
  <div class="title align-items-center me-auto">
    <i _ngcontent-serverapp-c11="" class="fas fa-tachometer-alt me-3"></i>
    <h5>Mi perfil</h5>
    <h2 class="float-start">
      Bienvenido(a) {{ session.firstName || '' | titlecase }}
      {{ session.lastName || '' | titlecase }}
    </h2>
  </div>
</div>

<div class="dashboard row mx-2">
  <div class="lg:col-4 md:col-6 lg:pl-0 mt-1">
    <app-card-dashboard
      title="Compras del periodo"
      [value]="ventaMes | currency"
      iconClass="fas fa-chart-bar"
      iconContainerClass="bg-green"
      [subtitle]="detalleVenta"
    />
  </div>

  @if (isB2B) {
  <div class="lg:col-4 md:col-6 lg:pl-0 mt-1">
    <app-card-dashboard-no-chart
      titulo="Mi crédito"
      iconClass="fas fa-credit-card"
      iconContainerClass="bg-purple"
      [data]="miCredito"
    />
  </div>
  } @if (isB2B) {
  <div class="lg:col-4 md:col-6 mt-1">
    <app-card-dashboard-no-chart
      titulo="Mis facturas por pagar"
      iconClass="fas fa-file-invoice-dollar"
      iconContainerClass="bg-danger"
      [data]="misFacturas"
    />
  </div>
  }
</div>

<div class="row mx-2 mb-3">
  <div class="col-12 py-0 mt-2">
    <app-card-dashboard-line-chart
      titulo="Últimos 12 períodos"
      iconClass="fas fa-chart-line"
      iconContainerClass="bg-fuchsia"
      [estado]="lineEstado"
      [lineChartOptions]="lineChartOptions"
      [lineChartData]="lineChartData"
    />
  </div>

  <!-- <div class="col-12 py-0 mt-2">
    <app-card-dashboard-horizontal-bar-chart
      titulo="Ventas por categoría"
      iconClass="fas fa-chart-bar"
      iconContainerClass="bg-info"
      [estado]="barEstado"
      [barChartOptions]="barChartOptions"
      [barChartData]="barChartData"
    ></app-card-dashboard-horizontal-bar-chart>
  </div> -->
</div>
